import script from "./edit-branches.vue?vue&type=script&setup=true&lang=js"
export * from "./edit-branches.vue?vue&type=script&setup=true&lang=js"

import "./edit-branches.vue?vue&type=style&index=0&id=ee5f332c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee5f332c"]])

export default __exports__